// Thin wrapper around the shared apiRequest() (a classic script, already
// global by the time this module runs) — supplies our own csrfToken and
// resetToLogin() as the 401 handler. resetToLogin lives in auth.js; importing
// it here would create a cycle (auth.js needs apiFetch too), so it's read off
// window instead, exactly like every other not-yet-migrated caller does.
import { csrfToken, viewingAsAdmin } from './state.js';

export async function apiFetch(path, opts = {}) {
  // While viewing as a parent, block every write client-side too — a second,
  // independent layer on top of the server's own 403 (Middleware::enforceViewAsReadOnly),
  // so a stray write button fails fast instead of round-tripping. Every call
  // site already does `catch (e) { toastError(e.message) }` on writes, so the
  // message here (not a separate toast() call, which would just get
  // overwritten by that catch) is what the user actually sees.
  // /view-as/exit and /auth/logout are exempt on both layers -- they're what
  // actually clears the mode server-side, so they must always go through.
  if (viewingAsAdmin && opts.method && opts.method !== 'GET'
      && path !== '/view-as/exit' && path !== '/auth/logout') {
    return Promise.reject(new Error('Read-only — exit View As to make changes.'));
  }
  return apiRequest(path, opts, csrfToken, window.resetToLogin);
}

window.apiFetch = apiFetch;
